export default import.meta.ROLLDOWN_FILE_URL_rLwn34g1VKkGjTLOsfU76g